// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"873":"c7281eea","981":"c7281eea"}[chunkId] + ".chunk.css";
};